import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaShoppingCart, FaHome, FaUser, FaEnvelope } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

function Header() {
  const { getCartCount } = useCart();
  const navigate = useNavigate();

  return (
    <header>
      <div className="header-container">
        <div className="header-top">
          <Link to="/" className="logo-section">
            <img src="/images/logo.jpg" alt="Fitness Health Blog Logo" className="logo-img" />
            <div className="logo-text">
              <h1>Fitness Health Blog</h1>
              <p>Your Wellness Journey Starts Here</p>
            </div>
          </Link>
          
          <div className="header-actions">
            <div className="cart-icon-container" onClick={() => navigate('/cart')}>
              <FaShoppingCart size={24} />
              {getCartCount() > 0 && (
                <span className="cart-count">{getCartCount()}</span>
              )}
            </div>
          </div>
        </div>
        
        <nav>
          <ul>
            <li><Link to="/"><FaHome /> Home</Link></li>
            <li><Link to="/about"><FaUser /> About Us</Link></li>
            <li><Link to="/contact"><FaEnvelope /> Contact</Link></li>
            <li><Link to="/cart"><FaShoppingCart /> Cart</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;